import { render, staticRenderFns } from "./DialogListagemCotas.vue?vue&type=template&id=a5a4dd46&scoped=true&"
import script from "./DialogListagemCotas.vue?vue&type=script&lang=js&"
export * from "./DialogListagemCotas.vue?vue&type=script&lang=js&"
import style0 from "./DialogListagemCotas.vue?vue&type=style&index=0&id=a5a4dd46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a4dd46",
  null
  
)

export default component.exports